<template>
    <div class="timeline-group timeline-item" v-for="group in messageGroup" 
        :data-ts="group.group_ts">
        <div class="timeline-date-header" :key="group.group_key">
            <p class="notification-date">
                <span class="date">{{ group.group_key }}</span>
            </p>
        </div>
        <transition-group
            name="notification"
            tag="div"
            class="notification-list"
            @enter="enter"
            @leave="leave"
            >
            <div class="notification"
                v-for="msg in group.messages" 
                :key="msg.id"
                @mouseenter="mouseEnterNotify(msg.id, msg.status)"
                :data-id="msg.id"
                :class="[{ removing: notificationRemoveAnimate === msg.id }, msg.status === 1 ? 'read' : 'unread']">
                <div class="notification-content"
                        :class="{active: msgFullHeightActive === msg.id}"
                        @click="fullNotify(msg.id)">
                    <div class="notification__content-text">
                        <div class="notification-category">
                            <p class="notification-category-text" :class="categoryNotify(msg.category, 'color')">
                                {{ typeNotify(msg.type) }}
                                <span class="notification-category-time">
                                    {{ msg.time }}
                                </span>
                            </p>
                        </div>
            
                        <div class="notification-message">
                            <p class="notification-text" :class="{active: msgFullHeightActive === msg.id}" v-html="msg.message"></p>
                        </div>
                    </div>
                    <span class="notifications-link remove-notifications" 
                        @click.stop.prevent="removeNotification(msg.id)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3838 11.7002L4.33474 5.65117C3.88842 5.20486 3.88842 4.48124 4.33474 4.03493C4.78105 3.58862 5.50467 3.58862 5.95098 4.03493L12 10.084L18.049 4.03493C18.4953 3.58862 19.219 3.58862 19.6653 4.03493C20.1116 4.48124 20.1116 5.20486 19.6653 5.65117L13.6162 11.7002L19.6653 17.7492C20.1116 18.1955 20.1116 18.9191 19.6653 19.3655C19.219 19.8118 18.4953 19.8118 18.049 19.3655L12 13.3164L5.95098 19.3655C5.50467 19.8118 4.78105 19.8118 4.33474 19.3655C3.88842 18.9191 3.88842 18.1955 4.33474 17.7492L10.3838 11.7002Z" fill="#C0C3C9"/>
                        </svg>
                    </span>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
import axios from '/webpack-assets/vue/config/axios-config';

  export default {
    name: 'NotificationMessage',
    emits: ['mouse-enter', 'remove-notify'],
    props: {
        messages: {
            type: Object,
            default: () => {},
        },
        language: {
            type: String,
            default: 'en',
        },
    },
    data() {
      return {
        msgFullHeightActive: null,
        notificationRemoveAnimate: null,
        categoryMap: {
            0: this.$t('General'),
            1: this.$t('Account'),
            2: this.$t('Cash flow'),
            3: this.$t('Orders'),
            5: this.$t('My store'),
            7: this.$t('Messages'),
            8: this.$t('Ticket'),
            9: this.$t('Dispute & Claim'),
            10: this.$t('Bookmark')
        },
        categoryColors: {
            0: 'blue',
            1: 'blue',
            2: 'green',
            3: 'blue',
            5: 'red',
            7: 'yellow',
            8: 'yellow',
            9: 'red',
            10: 'blue'
        },
        typeMap: {
            0: this.$t('Info'),
            1: this.$t('Error'),
            2: this.$t('Warning'),
            3: this.$t('Success')
        }
      };
    },
    computed: {
        messageGroup() {
            const groups = {}

            this.messages.forEach(msg => {
                const date = new Date(msg.created_at)

                const groupKey = this.formatGroupDate(date)

                if (!groups[groupKey]) {
                    groups[groupKey] = {
                    group_key: groupKey,
                    group_ts: date.setHours(0,0,0,0),
                    messages: []
                    }
                }

                groups[groupKey].messages.push({
                    ...msg,
                    time: this.formatTime(date)
                })
            })

            return Object.values(groups).sort((a,b) => b.group_ts - a.group_ts)
        }
    },
    methods: {
        mouseEnterNotify(id, status) {
            if(status === 0) {
                this.$emit('mouse-enter', id);
            }
        },
        categoryNotify(category, mode) {
            if (mode === 'color') {
            return this.categoryColors[category] || ''
            }

            return this.categoryMap[category] || ''
        },

        typeNotify(type) {
            return this.typeMap[type] || ''
        },
        async removeNotification(id) {
            try {
                const response = await axios.post(`/${this.language}/notification/hide/${id}`);
                const newNotification = response.data.html;
                const mainCount = response.data.main_count_unread;
                const inboxCount = response.data.inbox_count_unread;
                const countUnread = response.data.count_unread;

                if(newNotification?.created_at) {
                    console.log(newNotification)
                }

                this.notificationRemoveAnimate = id;
                
                setTimeout(()=>{
                    this.$emit("remove-notify", id, mainCount, inboxCount, countUnread);
                    this.notificationRemoveAnimate = null;
                }, 100)
                
            } catch (error) {
                console.error("Failed to remove notification:", error);
            }
        },
        fullNotify(id) {
            this.msgFullHeightActive = this.msgFullHeightActive === id ? null : id;
        },
        enter(el) {
            el.style.height = `${el.scrollHeight}px`;
            el.style.margin = '10px 0';
        },
        leave(el) {
            el.style.height = `${el.scrollHeight}px`;
            let animationFrameId;
            const animate = () => {
                el.style.height = '0';
                el.style.padding = '0';
                el.style.left = '25%';
                setTimeout(() => {
                    cancelAnimationFrame(animationFrameId);
                }, 1000);
            };
            animationFrameId = requestAnimationFrame(animate);
        },
        formatGroupDate(date) {
            const now = new Date()

            const today = new Date(now)
            today.setHours(0,0,0,0)

            const target = new Date(date)
            target.setHours(0,0,0,0)

            const diffDays = Math.round((target - today) / 86400000)

            if (diffDays === 0 || diffDays === -1) {
            return new Intl.RelativeTimeFormat(this.language, { numeric: 'auto' })
                .format(diffDays, 'day')
            }

            return new Intl.DateTimeFormat(this.language, {
            day: 'numeric',
            month: 'long'
            }).format(date)
        },

        formatTime(date) {
            return new Intl.DateTimeFormat(this.language, {
            hour: 'numeric',
            minute: '2-digit'
            }).format(date)
        }
    },
  };
  </script>
  <style lang="scss">
  .timeline-date-header{
    transition: .3s;
    &.removing{
        height: 0;
        opacity: 0;
    }
  }
  .notification{
    z-index: 2;
    &.removing{
        z-index: 1;
    }
  }
  .notification-enter-active,
  .notification-leave-active {
    transition: all 0.4s ease;
  }
  .notification-enter-from,
  .notification-leave-to {
    opacity: 0;
    height: 0;
    padding: 0;
  }
</style>